import React, { useEffect, useState } from 'react';
import { Box, Button, Modal, Paper, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { myContainerStyle } from '../../../configs/ui/constant';
import MaterialTable from 'material-table';
import {
   headerStyle,
   tableIcons,
   tableStyle,
} from '../../../configs/ui/TableConfig';
import Axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRedoAlt } from '@fortawesome/free-solid-svg-icons';
import { faFileDownload, faSpinner } from '@fortawesome/pro-duotone-svg-icons';
import CreateReportRedemption from '../../../components/Modal/Report/CreateReportRedemption';
import FileSaver from 'file-saver';
import { LogToBackend } from '../../../configs/helpers/LogToBackend';
import { useHistory } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import dayjs from 'dayjs';

const useStyles = makeStyles((theme) => ({
   modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
   },
   paper: {
      // display: 'flex',
      border: `1px solid ${theme.palette.divider}`,
      flexWrap: 'wrap',
   },
}));

const ReportRedeemtion = () => {
   const history = useHistory();
   const classes = useStyles();
   const [isLoading, setIsLoading] = useState(false);
   const { enqueueSnackbar, closeSnackbar } = useSnackbar();
   const [resp, setResp] = useState([]);
   const [data, setData] = useState([]);
   const [myModal, setMyModal] = useState('');
   const [showModal, setShowModal] = useState(false);

   useEffect(() => {
      getData(null);
   }, []);
   useEffect(() => {
      setTableData();
   }, [resp]);
   const getData = (value) => {
      setIsLoading(true);
      Axios.post('/GSB/dashboard/report/GetReportList', {
         reportType: 2,
      })
         .then((response) => {
            setResp(response.data);
         })
         .catch((e) => {
            LogToBackend(e);
            if (e.response) {
               const response = e.response.data;
               const statusCode = e.response.status;
               if (statusCode === 401) {
                  sessionStorage.clear();
                  localStorage.clear();
                  history.push('/');
               }
               enqueueSnackbar(response.errorAppMessageTh, {
                  variant: 'error',
               });
            } else console.error('site error');
         })
         .finally(() => {
            setIsLoading(false);
         });
   };
   const setTableData = () => {
      if (resp.length > 0) {
         const dataForMap = resp;
         const formatted = dataForMap.map((value) => {
            return Object.assign(
               {},
               {
                  ...value,
               },
            );
         });
         setIsLoading(false);
         setData(formatted);
      }
   };
   const refreshData = () => {
      setShowModal(false);
      setData([]);
      getData();
   };
   const downloadReport = (rowData) => {
      if (rowData.status === 1) {
         return false;
      } else {
         Axios.get(
            `/GSB/dashboard/report/DownloadReport?reportId=${rowData.reportId}`,
            {
               responseType: 'blob',
            },
         )
            .then((response) => {
               if (response) {
                  FileSaver.saveAs(
                     new Blob([response.data]),
                     rowData.reportName,
                  );
               }
            })
            .catch((err) => {
               LogToBackend(err);
               enqueueSnackbar('เกิดข้อผิดพลาด กรุณาตรวจสอบข้อมูล', {
                  variant: 'error',
               });
            });
      }
   };
   const setModalStyle = (type, value) => {
      if (type === 'create') {
         setMyModal(
            <CreateReportRedemption
               onClickClose={() => setShowModal(false)}
               onSuccess={() => refreshData()}
            />,
         );
      }
      setShowModal(!showModal);
   };
   return (
      <Paper style={myContainerStyle.root}>
         <Modal className={classes.modal} open={showModal}>
            <React.Fragment>{myModal}</React.Fragment>
         </Modal>
         <Box display='flex' my={1} alignItems='center'>
            <Box mx={1}>
               <Typography variant='h5'>รายงานการแลกของรางวัล</Typography>
            </Box>
            <Box mx={1}>
               <Button
                  variant='contained'
                  color='primary'
                  size='small'
                  startIcon={
                     <FontAwesomeIcon icon={faFileDownload} size={'xs'} />
                  }
                  onClick={() => {
                     setModalStyle('create', '');
                  }}
               >
                  ดาวน์โหลดไฟล์
               </Button>
            </Box>
         </Box>
         <Box>
            <MaterialTable
               isLoading={isLoading}
               columns={[
                  {
                     field: 'reportName',
                     title: 'ชื่อรายงาน',
                  },
                  {
                     field: 'reportDetail',
                     title: 'รายละเอียด',
                  },
                  {
                     field: 'creator',
                     title: 'ผู้ขอรายงาน',
                  },
                  {
                     field: 'createdTime',
                     title: 'เวลาที่สร้าง',
                     render: (rowData) =>
                        dayjs(new Date(rowData.createdTime)).format(
                           'DD/MM/BBBB  HH:mm',
                        ),
                  },
               ]}
               data={data}
               options={{
                  showTitle: false,
                  headerStyle: headerStyle,
                  padding: 'dense',
                  actionsColumnIndex: -1,
                  actionsCellStyle: {
                     color: '#ccc',
                  },
                  addRowPosition: 'first',
                  pageSize: 5,
                  pageSizeOptions: [5, 10, 25, 50, 100],
               }}
               localization={{
                  header: { actions: 'ตัวจัดการ' },
               }}
               style={tableStyle}
               icons={tableIcons}
               actions={[
                  {
                     icon: React.forwardRef((props, ref) => (
                        <FontAwesomeIcon
                           ref={ref}
                           {...props}
                           icon={faRedoAlt}
                           size={'xs'}
                        />
                     )),
                     tooltip: 'Refresh Data',
                     isFreeAction: true,
                     onClick: () => refreshData(),
                  },
                  (rowData) => ({
                     icon: React.forwardRef((props, ref) => (
                        <FontAwesomeIcon
                           ref={ref}
                           {...props}
                           icon={
                              rowData.status === 1 ? faSpinner : faFileDownload
                           }
                           color='#00a2e8'
                           spin={rowData.status === 1}
                        />
                     )),
                     tooltip:
                        rowData.status === 1 ? 'กำลังประมวลผล' : 'ดาวน์โหลด',
                     onClick: (event, rowData) => downloadReport(rowData),
                  }),
               ]}
            />
         </Box>
      </Paper>
   );
};

export default ReportRedeemtion;
